import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M13.2 0H1v18h16V3.8L13.2 0zm0 1.697L15.303 3.8H13.2V1.697zM15.8 16.8H2.2V1.2H12V5h3.8v11.8zm-5.46-7.806L7 6.49v4.176l.928-.464L9.329 13l1.484-.743-1.401-2.799.928-.464z" />
  </svg>
);

export default SvgComponent;
